import React from 'react'
import styled, { keyframes } from 'styled-components'
import { Config } from '../../../config'

export const AddToBasketCheckМark = ({
  color = Config.palette.silverTree,
}: {
  color?: string
}) => {
  return (
    <CSSVariables colorToUse={color}>
      <SvgCircle>
        <Track r="40%" cx="50%" cy="50%" />
        <Progress r="40%" cx="50%" cy="50%" />
        <SvgCheck viewBox="0 0 280 280" preserveAspectRatio="xMidYMin slice">
          <Check d="M95,150 l35,40 l65,-97" />
        </SvgCheck>
      </SvgCircle>
    </CSSVariables>
  )
}

const CSSVariables = styled.div<{ colorToUse: string }>`
  --check-mark-color: ${({ colorToUse }) => colorToUse};
  width: 100%;
  height: 100%;
`

const rotate = keyframes`
  to {
    stroke-dashoffset: 0;
  }
`

const SvgCircle = styled.svg`
  width: 100%;
  height: 100%;
`

const Track = styled.circle`
  stroke-width: 1;
  fill: none;
`

const Progress = styled.circle`
  fill: none;
  stroke-width: 0.2rem;
  stroke: var(--check-mark-color);
  stroke-linecap: round;
  fill: none;
  transform: rotate(270deg);
  transform-origin: center;
  stroke-dasharray: 1000;
  stroke-dashoffset: 1000;

  animation: ${rotate} 2s cubic-bezier(0.4, 0, 0.2, 1) 1 forwards;
`

const SvgCheck = styled.svg``

const draw = keyframes`{
  to {
    visibility: visible;
    stroke-dashoffset: 0;
  }
}`

const Check = styled.path`
  visibility: hidden;
  fill: none;
  stroke: var(--check-mark-color);
  stroke-width: 15;
  stroke-linecap: round;
  stroke-dasharray: 380;
  stroke-dashoffset: 380;
  animation: ${draw} 1s 0.5s 1 ease forwards;
`
